module.exports = __webpack_public_path__ + "img/ceramic-green.07b19eec.webp";